import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/tempcar/feerule/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/tempcar/feerule/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/remove/v2', qs.stringify(params), options);

export const syncFeeRule = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/sync/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/submit/v2', params, options);

export const test = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/test/v2', params, options);
